<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col cols="12" md="8" class="d-flex grey lighten-2" style="min-height: 50vh">
        <v-img
          v-if="car"
          :src="car.images.main.src"
          class="black"
          @click="$emit('click')"
          style="cursor: pointer"
        ></v-img>
      </v-col>

      <v-col cols="12" md="4" class="grey lighten-5">
        <v-card v-if="car" flat tile class="px-md-8 pt-md-4" color="transparent">
          <v-card-title class="d-flex flex-column align-start">
            <price-sheet :price="car.price"></price-sheet>
            <div class="text-subtitle-1 font-weight-medium">{{ car.title }}</div>
          </v-card-title>

          <v-card-text>
            <div class="my-md-4">
              <v-container v-if="isSmallScreen" fluid>
                <v-row>
                  <v-col class="pa-0" cols="6">
                    <div class="label font-italic">STATUS</div>
                    <div class="text-body black--text">
                      {{ car.status }}
                    </div>
                  </v-col>
                  <v-col v-if="car.year" class="pa-0" cols="6">
                    <div class="label font-italic">YEAR</div>
                    <div class="text-body black--text">
                      {{ car.year }}
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-6">
                  <v-col v-if="car.engine" class="pa-0" cols="6">
                    <div class="label font-italic">ENGINE</div>
                    <div class="text-body black--text">
                      {{ car.engine }}
                    </div>
                  </v-col>
                  <v-col v-if="car.fuel" class="pa-0" cols="6">
                    <div class="label font-italic">FUEL</div>
                    <div class="text-body black--text">
                      {{ car.fuel }}
                    </div>
                  </v-col>
                </v-row>
              </v-container>
              <div v-else>
                <div class="label font-italic">STATUS</div>
                <div class="text-body black--text">
                  {{ car.status }}
                </div>
                <div v-if="car.year" class="mt-2">
                  <div class="label font-italic">YEAR</div>
                  <div class="text-body black--text">
                    {{ car.year }}
                  </div>
                </div>
                <div v-if="car.engine" class="mt-2">
                  <div class="label font-italic">ENGINE</div>
                  <div class="text-body black--text">
                    {{ car.engine }}
                  </div>
                </div>
                <div v-if="car.fuel" class="mt-2">
                  <div class="label font-italic">FUEL</div>
                  <div class="text-body black--text">
                    {{ car.fuel }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-md-8 mt-4">
              <div>
                <brand-chip :to="`/brand/${car.brandLogicalName}`" class="mr-2 my-1">{{
                  car.brand
                }}</brand-chip>
                <brand-chip v-if="car.class" class="mr-2 my-1">{{ car.class }}</brand-chip>
                <brand-chip v-if="car.model" class="my-1">{{ car.model }}</brand-chip>
              </div>
            </div>
            <div class="mt-md-8 mt-4 black--text">
              {{ car.description }}
            </div>
          </v-card-text>
        </v-card>
        <v-skeleton-loader
          class="px-md-8 pt-4"
          v-else
          boilerplate
          type="article@2"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PriceSheet from "./PriceSheet.vue"
import BrandChip from "./BrandChip.vue"

export default {
  props: ["car"],
  emits: ["click"],
  computed: {
    isSmallScreen() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },

  methods: {
    call() {
      window.open("tel:900300400")
    },
  },
  components: {
    PriceSheet,
    BrandChip,
  },
}
</script>

<style scoped>
.label {
  font-size: 0.65em;
  margin-bottom: -8px;
}
</style>
